import { get, omit, pick } from '../utils/PolyfillLodash'

const getRenderingAttr = params => {
  const parsedRenderingAttr = JSON.parse(params.renderingAttr)
  const attrVal = get(parsedRenderingAttr, params.attrName)
  let val = params.defaultVale
  if (parsedRenderingAttr && attrVal) {
    val = parsedRenderingAttr[params.attrName]
    if (typeof params.callback === 'function') {
      val = params.callback(val)
    }
  }
  return val
}

const getHookLogicProductAdData = data => {
  let productAd = {}
  const reqAttr = [
    'ProductSKU',
    'ProductPage',
    'ImpBeacon',
    'ClickBeacon',
    'ParentSKU',
    'Rating',
    'RenderingAttributes'
  ]
  const myData = pick(data, reqAttr)
  if (get(myData, 'Rating') && get(myData, 'RenderingAttributes')) {
    productAd = {
      ...omit(myData, ['RenderingAttributes', 'Rating']),
      avgRating: Number(myData.Rating),
      reviewsCount: getRenderingAttr({
        attrName: 'numberOfReviews',
        renderingAttr: myData.RenderingAttributes,
        callback: val => (val && Number(val) ? Number(val) : 0),
        defaultValue: 0
      })
    }
  } else {
    productAd = data
  }

  return productAd
}

export default getHookLogicProductAdData
